import { Component } from '@angular/core';

@Component({
  selector: 'app-shared-horiz-bar',
  templateUrl: './shared-horiz-bar.component.html',
  styleUrls: ['./shared-horiz-bar.component.scss']
})
export class SharedHorizBarComponent {

}
